import { Delete } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import {
    Box,
    Button,
    Grid,
    IconButton,
    Paper,
    Tooltip,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { safeDateFormat } from "qubCommon/helperMethods/dateHelper";

const ProgramPeriodsTable = ({ rows = [], onEdit, onDelete }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    if (!rows || !rows.length) return null;

    if (isMobile) {
        // 📱 Mobile card layout
        return (
            <Box sx={{ mt: 2 }}>
                {rows.map((row, idx) => (
                    <Paper
                        key={row.id || idx}
                        elevation={0}
                        sx={{
                            border: "1px solid #dcdcdc",
                            borderRadius: 1.5,
                            mb: 1.5,
                            p: 2,
                            backgroundColor: row.isActive ? "#f9fff9" : "#fff",
                        }}
                    >
                        <Typography color="primary" fontWeight={700} sx={{ mb: 0.5 }}>
                            Έτος {row.description}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Έναρξη:{" "}
                            <Typography component="span" color="text.primary">
                                {safeDateFormat(row.dateFrom)}
                            </Typography>
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Λήξη:{" "}
                            <Typography component="span" color="text.primary">
                                {safeDateFormat(row.dateTo)}
                            </Typography>
                        </Typography>

                        {row.isActive && (
                            <Typography
                                variant="body2"
                                sx={{ mt: 0.5, fontWeight: 600, color: "success.dark" }}
                            >
                                ✓ Ενεργή Περίοδος
                            </Typography>
                        )}

                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            sx={{
                                mt: 1.5,
                                alignSelf: "flex-end",
                                textTransform: "none",
                                borderRadius: 2,
                                fontWeight: 600,
                            }}
                            onClick={() => onEdit?.(row)}
                        >
                            Επεξεργασία
                        </Button>
                    </Paper>
                ))}
            </Box>
        );
    }

    // 🖥️ Desktop grid layout
    return (
        <Box
            sx={{
                border: "1px solid #dcdcdc",
                borderRadius: 1.5,
                overflow: "hidden",
                mt: 2,
            }}
        >
            {/* Header */}
            <Grid
                container
                sx={{
                    backgroundColor: "#f2f2f2",
                    borderBottom: "1px solid #dcdcdc",
                    py: 1,
                    px: 2,
                }}
            >
                <Grid item xs={2}>
                    <Typography fontWeight={600}>Έτος</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography fontWeight={600}>Περιγραφή</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography fontWeight={600}>Σύντμηση</Typography>
                </Grid>
                <Grid item xs={1.5}>
                    <Typography fontWeight={600}>Έναρξη</Typography>
                </Grid>
                <Grid item xs={1.5}>
                    <Typography fontWeight={600}>Λήξη</Typography>
                </Grid>
                <Grid item xs={2} >
                    <Typography fontWeight={600}>Υπουργική Απόφαση</Typography>
                </Grid>

                <Grid item xs={2} textAlign="right">
                    <Typography fontWeight={600}>Ενέργεια</Typography>
                </Grid>
            </Grid>

            {/* Rows */}
            {rows.map((row, idx) => (
                <Grid
                    key={row.id || idx}
                    container
                    alignItems="center"
                    sx={{
                        backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff",
                        borderBottom: idx < rows.length - 1 ? "1px solid #e0e0e0" : "none",
                        py: 1.2,
                        px: 2,
                    }}
                >
                    <Grid item xs={2}>
                        <Typography color="primary" fontWeight={600}>
                            {row.id}
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography>{row.description}</Typography>
                    </Grid>
                    <Grid item xs={1}>
                        <Typography>{row.abbr}</Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                        <Typography>{safeDateFormat(row.dateFrom)}</Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                        <Typography>{safeDateFormat(row.dateTo)}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography>{row.decision}</Typography>
                    </Grid>
                    <Grid item xs={2} textAlign="right">
                        <Tooltip title="Επεξεργασία">
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => onEdit?.(row)}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Διαγραφή">
                            <IconButton
                                size="small"
                                color="error"
                                onClick={() => onDelete?.(row)}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>

                </Grid>
            ))}
        </Box>
    );
};

export default ProgramPeriodsTable;
